import React from 'react';
import { MoonIcon } from 'lucide-react';
export const Hero = () => {
  return <section className="w-full bg-gradient-to-b from-indigo-50 to-white pt-24 pb-16 md:pt-32 md:pb-24" data-id="element-313">
      <div className="container mx-auto px-4 md:px-6" data-id="element-314">
        <div className="flex flex-col md:flex-row items-center" data-id="element-315">
          <div className="md:w-1/2 md:pr-12" data-id="element-316">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-indigo-900 leading-tight mb-4" data-id="element-317">
              Stop Fighting Sleep. Start Supporting It Naturally.
            </h1>
            <p className="text-lg md:text-xl text-indigo-800 mb-6" data-id="element-318">
              Discover why 4,00,000+ Indians are choosing Setu's Sleep Restore
              Melatonin Strips over sleeping pills for deeper, dependency-free
              rest
            </p>
            <div className="bg-white p-6 rounded-lg shadow-md mb-8" data-id="element-319">
              <p className="text-gray-700 mb-4" data-id="element-320">
                Tired of lying awake at 2 AM, scrolling through your phone?
                Frustrated with groggy mornings after taking sleeping pills?
                You're not alone.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-321">
                Traditional sleeping pills force your body into unconsciousness,
                but they don't give you real, restorative sleep. Setu's Sleep
                Restore works differently—it gently guides your body back to its
                natural sleep rhythm, so you wake up refreshed, not drowsy.
              </p>
              <p className="text-gray-700 font-medium" data-id="element-322">
                The difference? Pills sedate you. Melatonin strips restore you.
              </p>
            </div>
            <div className="flex items-center justify-center md:justify-start mb-6" data-id="element-323">
              <div className="bg-indigo-100 rounded-lg p-3 shadow-sm mr-4" data-id="element-324">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/og45cR6GEKB2RvPaD1aJ2B/Screenshot_2025-08-25_at_9.01.12_PM.png" alt="Sleep Restore Melatonin Strips" className="h-24 rounded-lg" data-id="element-325" />
              </div>
              <div data-id="element-326">
                <div className="flex items-center" data-id="element-327">
                  <div className="h-3 w-3 bg-green-500 rounded-full mr-2" data-id="element-328"></div>
                  <p className="text-sm font-medium" data-id="element-329">Mint Flavored Strips</p>
                </div>
                <div className="flex items-center mt-1" data-id="element-330">
                  <div className="h-3 w-3 bg-green-500 rounded-full mr-2" data-id="element-331"></div>
                  <p className="text-sm font-medium" data-id="element-332">5mg Melatonin</p>
                </div>
              </div>
            </div>
          </div>
          <div className="md:w-1/2 mt-10 md:mt-0" data-id="element-333">
            <div className="relative" data-id="element-334">
              <div className="absolute -top-6 -left-6 w-20 h-20 bg-indigo-100 rounded-full flex items-center justify-center" data-id="element-335">
                <MoonIcon className="h-10 w-10 text-indigo-600" data-id="element-336" />
              </div>
              <img src="https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1742&q=80" alt="Person sleeping peacefully" className="rounded-lg shadow-xl w-full object-cover h-[400px]" onError={e => {
              e.target.src = 'https://images.unsplash.com/photo-1455642305367-68834a1da7ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80';
            }} data-id="element-337" />
              <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-lg shadow-lg" data-id="element-338">
                <div className="flex items-center" data-id="element-339">
                  <div className="h-3 w-3 bg-green-500 rounded-full mr-2" data-id="element-340"></div>
                  <p className="text-sm font-medium" data-id="element-341">Natural Sleep Cycle</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};